import React from 'react';
import { Button, Image, Checkbox } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { WorkTaskGroup } from '../models/worktaskgroup';
import { WorkTaskGroupService } from '../services/worktaskgroup.service';

interface IState {
  workTaskGroups: WorkTaskGroup[];
  status: string;
  columns: any;
}

export class WorkTaskGroupsPage extends React.Component<any, IState> {

  constructor(props: any) {
    super(props);

    this.state = {
      workTaskGroups: new Array<WorkTaskGroup>(),
      status: "",
      columns: [{
        dataField: 'id',
        text: 'ID',
        headerStyle: () => {
          return { width: '5%' };
        },
        sort: true
      },
      {
        dataField: 'groupImage',
        text: 'Slika',
        formatter: (cellContent, row) => {
          return (
            <Image src={row.groupImage} />
          );
        }
      },
      {
        dataField: 'groupName',
        text: 'Naziv grupe zadataka',
        sort: true,
        filter: textFilter()
      }, 
      {
        dataField: 'groupOrderKey',
        text: 'Poredak (od najmanjeg broja do najvećeg)',
        sort: true,
        filter: textFilter()
      },
      {
        dataField: 'groupVisible',
        text: 'Grupa vidljiva unutar mobilne app?',
        sort: true,
        formatter: (cellContent, row) => {
          return (
            <Checkbox checked={row.groupVisible} disabled />
          );
        }
      },
      {
        dataField: 'edit',
        isDummyField: true,
        text: 'Uredi',
        formatter: (cellContent, row) => {
          return (
            <React.Fragment>
              <LinkContainer to={'/worktaskgroup/edit/' + row.id}>
                <Button className="btn-primary">
                  Uredi grupu zadataka
                </Button>
              </LinkContainer>
              <br/>
              <LinkContainer to={'/worktask/editbygroup/' + row.id}>
                <Button className="btn-warning mt-10" >
                  Uredi zadatke
                </Button>
              </LinkContainer>
            </React.Fragment>
          );
        }
      }]
    };
  }

  componentDidMount() {
    WorkTaskGroupService.getAll()
      .then(
        response => {
          this.setState({
            workTaskGroups: response
          });
        },
        error => {
          this.setState({
            status: error.message
          });
        }
      );
  }
  
  render() {
    return (
      <div>
        <h1 className="page-title">Grupe zadataka</h1>
        <div className="row form-group">
          <div className="col-md-12">
              <LinkContainer to={'/worktaskgroup/edit'}>
                <Button className="btn-primary">
                  Kreiraj novu grupu zadataka
                </Button>
              </LinkContainer>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            { this.state.status &&
              <div className={'alert alert-danger'}>{this.state.status}</div>
            }
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <BootstrapTable 
              striped
              hover
              keyField='id' 
              data={ this.state.workTaskGroups } 
              columns={ this.state.columns }
              filter={ filterFactory() } 
              pagination={ paginationFactory() }/>
          </div>
        </div>
      </div>
    );
  }
}